import { useHistory } from 'react-router';
import { useWeb3React } from '@web3-react/core';
import { Web3Provider } from '@ethersproject/providers';
import { ethers, Contract } from 'ethers';
import { motion } from 'framer-motion';
import PlayerIcon from '../Utils/PlayerIcon';

interface IProps {
  gameData: {
    address: string;
    players: {
      player1: string;
      player2: string;
      player3: string;
      player4: string;
      player5: string;
    };
    entryFee: string;
  };
  contract: Contract;
}

// shorten the name of the player
const shorter = (str: any) =>
  str?.length > 8 ? `${str.slice(0, 4)}...${str.slice(-3)}` : str;

const DJackLobbyJoin: React.FC<IProps> = ({ gameData, contract }: IProps) => {
  // states and contexts
  const { account } = useWeb3React<Web3Provider>();
  const history = useHistory();

  // UI functions
  const handleJoin = async (seat: number) => {
    try {
      await contract.join(gameData.address, seat, {
        value: gameData.entryFee
      });
    } catch (error: any) {
      if (error.data) {
        window.alert(error.data.message);
      } else {
        window.alert(error.message);
      }
    }
  };

  const onJoin = async (seat: number) => {
    if (account) {
      await handleJoin(seat);
      history.push(`/djackgame/${gameData.address}`);
    }
  };

  return (
    <motion.div
      key={gameData.address}
      variants={{
        open: {
          opacity: 1,
          width: 'auto',
          transition: {
            duration: 1.2,
            ease: 'easeInOut',
            delayChildren: 0.2,
            staggerChildren: 0.2
          }
        },
        collapsed: { opacity: 0, width: '0px' }
      }}
    >
      <div className="djackLobbyJoinContainer">
        {Object.entries(gameData.players).map(([key, value], index) =>
          value === ethers.constants.AddressZero ? (
            <motion.div
              key={`${gameData.address}-djackLobbyJoinContentJoinButton${key}`}
              variants={{
                open: { opacity: 1 },
                collapsed: { opacity: 0 }
              }}
            >
              <button
                type="button"
                className="djackLobbyJoinButton"
                onClick={() => onJoin(index)}
                disabled={
                  !account || Object.values(gameData.players).includes(account)
                }
              >
                +
              </button>
            </motion.div>
          ) : (
            <motion.div
              key={`${gameData.address}-djackLobbyJoinContent${key}`}
              variants={{
                open: { opacity: 1 },
                collapsed: { opacity: 0 }
              }}
            >
              <div
                className="playerWrapper"
                onClick={() => history.push(`/djackgame/${gameData.address}`)}
                style={{ cursor: 'pointer' }}
              >
                <div className="playerIcon">
                  <PlayerIcon active={value === account} />
                </div>
                <div
                  className="playerText"
                  style={{
                    color: value === account ? '#f8f8f8' : '#d3d3d3',
                    width: '42px'
                  }}
                >
                  {value !== ethers.constants.AddressZero
                    ? shorter(value)
                    : '-'}
                </div>
              </div>
            </motion.div>
          )
        )}
        <motion.div
          key={`${gameData.address}-djackLobbyJoinContentGameFee`}
          variants={{
            open: { opacity: 1 },
            collapsed: { opacity: 0 }
          }}
        >
          <div
            className="djackLobbyJoinInfoWrapper"
            onClick={() => history.push(`/djackgame/${gameData.address}`)}
          >
            <span className="djackLobbyJoinInfoText">JOIN&nbsp;FEE</span>
            <div className="djackLobbyJoinInfoValueContainer">
              <span className="djackLobbyJoinInfoValue">
                {Number(ethers.utils.formatEther(gameData.entryFee)) < 1
                  ? Math.round(
                      Number(ethers.utils.formatEther(gameData.entryFee)) * 100
                    ) / 100
                  : Math.round(
                      Number(ethers.utils.formatEther(gameData.entryFee)) * 10
                    ) / 10}
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default DJackLobbyJoin;
